import Vue from "vue";
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
      locationFlag:true,
      seachflag:false,
      fankuiflag:false,
      homefankuiflag:false,
    },
    mutations:{
      locationFlagchange(state,payload){
        state.locationFlag = payload
      },
      seachflagchange(state,payload){
        state.seachflag = payload
      },
      fankuiflag(state,payload){
        state.fankuiflag = payload
      },
      homefankuiflag(state,payload){
        state.homefankuiflag = payload
      },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js